import React, { Component } from 'react';
import { redirectToPlayerDetails } from '../../routing/redirectService';
import './PlayerIdAndName.scss';

class PlayerIdAndName extends Component {
    onClickViewProfile(playerId) {
        redirectToPlayerDetails(playerId);
    }

    render() {
        return (
            <div className="player-info">
                <span className="alerts-list-player-name">
                    {this.props.username}
                </span>
                {/*<span className='player-id-profile'>{this.props.id}</span>*/}
                <span
                    className="player-id"
                    onClick={() => this.onClickViewProfile(this.props.id)}
                >
                    {this.props.id}
                </span>
            </div>
        );
    }
}

export default PlayerIdAndName;
